// DS: DS6.1 - Radio button semantics
import React from 'react';
import c from 'classnames';
import RadioButton, {
  type RadioButtonProps,
  type AvailableRefs,
} from '../../../../RadioButton';
import { useListItem, CommonListItemAPI } from '../../common';
import ListItemContent from '../../legos/ListItemContent';
import commonStyles from '../../common.scss';
import s from './ListItemRadioButton.scss';

export interface Props
  extends Omit<RadioButtonProps, 'inputClassName' | 'onChange' | 'prefix'>,
    CommonListItemAPI {
  inputClassName?: string;
  onChange?: (isSelected: boolean, value?: string) => void;
  controlAlignment?: 'top' | 'center';
}

const ListItemRadioButton: React.FC<Props> = unfilteredProps => {
  const {
    rootProps: {
      name,
      value,
      onChange,
      checked,
      controlAlignment = 'top',
      className,
      inputClassName,
      ...rest
    },
    contentProps,
    ref,
  } = useListItem<AvailableRefs, Props>(unfilteredProps);

  return (
    <RadioButton
      ref={ref}
      className={c(
        s['root'],
        controlAlignment === 'center' && s['align-items-center'],
        className
      )}
      inputClassName={c(commonStyles['input'], inputClassName)}
      name={name || ''}
      value={value || ''}
      onChange={onChange && (() => onChange(!checked, value))}
      checked={checked}
      {...rest}
    >
      <ListItemContent {...contentProps} />
    </RadioButton>
  );
};

ListItemRadioButton.displayName = 'ListItemRadioButton';

export default ListItemRadioButton;
